<template>
	<v-modal>
		<template v-slot:header>
			<h1>About the leasehold information form (TA7)</h1>
		</template>
		<template v-if="showBack" v-slot:back>
			<button class="v-modal__header__actions__back" @click.prevent="$vmodal.back()">About protocol packs</button>
		</template>
		<section>
			<header class="mt-2">
				<h1 class="beta heavy">Instructions</h1>
			</header>
			<div class="editorial mt-2">
				<p>The seller should provide all relevant documentation relating to the lease when they return this completed form to their solicitor. This may include documents given to the seller when they purchased the property, or documents subsequently given to the seller by those managing the property.</p>
			</div>
		</section>
		<section>
			<header class="mt-2">
				<h1 class="beta heavy">Definitions</h1>
			</header>
			<div class="editorial mt-2">
				<ul>
					<li>'Seller' means all sellers together where the property is owned by more than one person.</li>
					<li>'Property' means the leasehold property being sold.</li>
					<li>'Building' means the building containing the property.</li>
					<li>'Neighbour' means those occupying flats in the building.</li>
				</ul>
			</div>
		</section>
	</v-modal>
</template>
<script>
export default {
	props: {
		showBack: {
			required: false,
			type: Boolean,
			default() {
				return false;
			},
		},
	},
};
</script>
